import { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Colors from '../assets/color';
import logo from "../assets/images/splitev_logo.svg";
import snackBar from "../assets/icons/snackbar.svg";
import Drawer from '@mui/material/Drawer';

const navItems = [
  { label: 'Solutions', path: '/why-splitev' },
  // { label: 'Plans & Pricing', path: '/plans' },
  // { label: 'Resources', path: '/give-away' },
  { label: 'Company', path: '/about-splitev' },
];

function NavBar({ isSimpleMode }) {
  const BLUR_NAVBAR_AT_SCROLL_POSITION = 100;
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isBlurNavBar, setIsBlurNavBar] = useState(false);

  const toggleDrawerHandler = () => {
    setToggleDrawer(!toggleDrawer);
  }

  window.addEventListener("scroll", function () {
    const scrollPosition = window.scrollY;

    if (scrollPosition > BLUR_NAVBAR_AT_SCROLL_POSITION) {
      setIsBlurNavBar(true);
      return;
    }

    setIsBlurNavBar(false);
  });

  return (
    <>
      <Box sx={{
        height: { xs: '5.6rem', sm: '6.4rem', md: '7.2rem' },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: '2rem', sm: '2rem', md: '6.4rem' },
        position: 'fixed',
        width: '100%',
        zIndex: 100,
        background: `${isBlurNavBar ? "rgba(255, 255, 255, 0.1)" : "transparent"}`,
        backdropFilter: `${isBlurNavBar ? "blur(10px)" : "transparent"}`,
        boxShadow: `${isBlurNavBar ? "0 4px 30px rgba(0, 0, 0, 0.1)" : ""}`,
      }}>

        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
          gap: { md: '4rem' }
        }}>
          <Box component='a' href='/' sx={{
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
          }}>
            <Box
              component="img"
              sx={{
                height: { xs: '2.8rem', sm: '3.4rem' },
                width: 'auto'
              }}
              src={logo}
              alt="logo"
            />
          </Box>

          {!isSimpleMode &&
            <Box
              sx={{
                display: {
                  xs: 'none', lg: "flex"
                },
                gap: { md: '2rem' }
              }}>

              {navItems.map((item) => (
                <Box
                  key={item.label}
                  component="a"
                  href={item.path}
                  sx={{
                    color: 'white',
                    fontSize: { sm: "1.2rem", md: '1.6rem' },
                    fontWeight: 500,
                    textDecoration: 'none',
                    lineHeight: '2.7rem',
                    fontFamily: 'mulish'
                  }}>
                  {item.label}
                </Box>
              ))}
            </Box>}
        </Box>

        <Box sx={{ display: "flex", gap: "1.6rem", alignItems: "center" }}>
          {!isSimpleMode && <Box
            component="a"
            // href="https://play.google.com/store/apps/details?id=com.split_ev_mobile.app"
            href="mailto:charge@splitev.co"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: Colors.black,
              p: { xs: "0.6rem 1.6rem", md: "1.2rem 2.4rem" },
              borderRadius: '2.5rem',
              fontSize: { xs: "1.3rem", sm: "1.4rem", md: "1.6rem" },
              fontWeight: 700,
              fontFamily: 'mulish',
              backgroundColor: Colors.white,
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1rem',
              height: { xs: '3.5rem', sm: '4rem' },
            }}>
            Join the network
          </Box>}

          <Box
            component="img"
            src={snackBar}
            alt="snackbar"
            onClick={toggleDrawerHandler}
            sx={{
              objectFit: "contain",
              width: "2rem",
              display: { xs: 'flex', lg: 'none' },
            }}
          />
        </Box>

        <Drawer open={toggleDrawer} onClose={toggleDrawerHandler}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyItems: "center",
              gap: '2rem',
              background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
              height: "100%",
              width: "25rem",
              padding: "5rem",
            }}>

            {navItems.map((item) => (
              <Box
                key={item.label}
                component="a"
                href={item.path}
                sx={{
                  color: 'white',
                  fontSize: "2rem",
                  fontWeight: 700,
                  textDecoration: 'none',
                  lineHeight: '2.7rem',
                }}>
                {item.label}
              </Box>
            ))}

            <Box component='a' href='/'
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
                position: 'absolute',
                bottom: '6rem'
              }}>
              <Box
                component="img"
                sx={{
                  height: { xs: '3rem', sm: '3.4rem' },
                  width: 'auto'
                }}
                src={logo}
                alt="logo"
              />
            </Box>

          </Box>
        </Drawer>
      </Box>
    </>
  );
}

NavBar.propTypes = {
  window: PropTypes.func,
};

export default NavBar;